import { deserializeData } from '@apeiron/temp'
import { useMutation } from '@apollo/client'
import { GuildType } from '@src/constants/guild'
import { changeGuildSchema } from '@src/deserialize/yup/guild'
import graphql from '@src/graphql/mutation/changeGuild'
import { useCallback, useState } from 'react'

const useChangeGuild = (): Hook => {
  const [changeGuild, { loading }] = useMutation(graphql)

  const [data, setData] = useState<Response>(false)

  const mutate = useCallback(
    async (request: Request): Promise<Response> => {
      const { id, type } = request

      const response = await changeGuild({
        variables: {
          id,
          type
        }
      })

      const result =
        deserializeData<boolean>(response, changeGuildSchema) || false

      setData(result)

      return result
    },
    [changeGuild]
  )

  return {
    mutate,
    data,
    loading
  }
}

type Request = {
  id: string
  type: GuildType
}

type Response = boolean

type Hook = {
  data: Response
  loading: boolean
  mutate: (request: Request) => Promise<Response>
}

export default useChangeGuild
